<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">发证记录</div>
    <div style="padding: 0 10px;">
      <div class="gj_top_class" style="margin-bottom: 10px;">
        <input name="" type="button" class="btn_s_gj" @click="search(filters)"/>
        <input name="" type="text" class="put_gj" placeholder="证书编号, 公司名, 人名" @keyup.13="search(filters)" v-model="filters.content" />
        <select v-model="filters.type">
          <option value="">全部</option>
          <option value="0">证书编号</option>
          <option value="1">人员名</option>
          <option value="2">公司名</option>
        </select>
        <button class="watch ml18 mr40" style="cursor: pointer;" @click="search(filters)">查询</button>
      </div>
      <div class="gj_list" style="min-height:720px;">
        <el-table v-if="tableData.data && tableData.data.length > 0"
                  :data="tableData.data" stripe border
                  style="width: 100%">
          <el-table-column label="证书编号">
            <template slot-scope="scope">
              {{scope.row.certLibrary.certNumber}}
            </template>
          </el-table-column>
          <el-table-column label="发送时间">
            <template slot-scope="scope">
              {{scope.row.certLibrary.createDate}}
            </template>
          </el-table-column>
          <el-table-column label="授证对象">
            <template slot-scope="scope">
              <span v-if="scope.row.certLibrary.itemType == '98'">{{scope.row.name}}</span>
              <span v-if="scope.row.certLibrary.itemType == '99'">{{scope.row.depName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期" width="120">
            <template slot-scope="scope">
              {{dateFormat(new Date(scope.row.certLibrary.certDataJson.expiringDate), 'yyyy-MM-dd')}}
            </template>
          </el-table-column>
          <el-table-column label="点击查看" width="100">
            <template slot-scope="scope">
              <a :href="scope.row.certLibrary.certPath" title="证书" style="cursor: pointer;" target="_blank">
                <img :src="scope.row.certLibrary.certPath" alt="" height="48">
              </a>
            </template>
          </el-table-column>
          <el-table-column width="40">
            <template slot-scope="scope">
              <a class="el-icon-delete" @click="cancel(scope.row.certLibrary.id)" title="取消发证" style="cursor: pointer;"></a>
            </template>
          </el-table-column>
        </el-table>
        <h5 class="none_ts" v-if="tableData.data.length == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="tableData.data.length > 0">共{{cnt}}条记录</dt>
        <dd v-if="tableData.data.length > 0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import utils from '@/utils'
  import Paginate from 'vuejs-paginate'
  export default {
    components: { Paginate },
    data () {
      return {
        dateFormat: utils.dateFormat,
        pages: 0,
        cnt: 0,
        tableData: {
          data: []
        },
        filters: {
          pageNo: 1,
          pageSize: 7,
          delFlag: '0',
          content: '',
          type: '' // 0-证书编号，1-人名（模糊），2-公司名（模糊）
        }
      }
    },
    created () {
      this.search(this.filters)
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      search (filters) {
        let f = filters
        if (!filters.type) { f.content = '' }
        api.post(config.bylApiPath, '/cert/manualCertHistory', f, (r) => { // 正常
          this.pages = Math.ceil(r.cntData / this.filters.pageSize)
          this.cnt = r.cntData
          if (r.data) {
            this.tableData.data = r.data
          } else {
            this.tableData.data = []
          }
        })
      },
      cancel (id) {
        var that = this
        this.confirmBox({
          title: '取消证书',
          text: '确认取消发送的证书吗？',
          yes: function () {
            api.post(config.bylApiPath, '/cert/delete', {id: id}, r => {
              that.$toasted.show('证书已取消')
              that.search(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/byl/org/cert/record.vue